import { UsersList } from "./usersList";
import { Breadcrumb, Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import "./users.css";
import Title from "../UI/Title/Title";
import { ChangeEvent, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { getUsers } from "../../api/users";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AddButton from "../UI/AddButton/addbutton";
import ResetButton from "../UI/ResetButton/resetbutton";
import { Search } from "../UI/Search/Search";
import { FilterInput } from "../UI/FilterApi/filterapi";

function Users() {
  const { t } = useTranslation("common");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState<number>(1);
  const [users, setUsers] = useState<any>();
  const [isActive, setIsActive] = useState<boolean | undefined>(undefined);
  const navigate = useNavigate();

  const { mutateAsync: getUsersMutation, isLoading } = useMutation(
    "users",
    ({ search, page }: { search: string; page: number }) =>
      getUsers(search, page * 10 + 10, isActive),
    {
      onSuccess: (res) => {
        setUsers(res);
      },
    }
  );

  const resetFilters = () => {
    setTableKey((tableKey) => tableKey + 1);
    setSearch("");
    setIsActive(undefined);
  };
  const [tableKey, setTableKey] = useState(0);

  useEffect(() => {
    getUsersMutation({ search, page });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);
  return (
    <>
      <Row gutter={[10, 10]}>
        <Col offset={1}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },

              {
                title: (
                  <span className="breadcrumbcolor">{t("users-list")}</span>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          <Title title={`${t("Users List")}`} />
        </Col>

        <Col offset={1} span={4}>
          <Search
            value={search}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setSearch(e.target.value);
            }}
            onEnter={() =>
              getUsersMutation({
                search,
                page,
              })
            }
          />
        </Col>

        <Col span={2}>
          <FilterInput
            key={""}
            onChange={(e: boolean) => setIsActive(e)}
            value={isActive}
          />
        </Col>

        <Col
          offset={14}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <ResetButton
            onClick={() => {
              resetFilters();
            }}
          />

          <AddButton
            onClick={() => {
              navigate("/users/create");
            }}
          />
        </Col>

        <Col offset={1} span={22} className="users-list">
          <UsersList
            tableKey={tableKey}
            data={users?.data.data}
            loading={isLoading}
            getUsersMutation={getUsersMutation}
            page={page}
            setPage={setPage}
          />
        </Col>
      </Row>
    </>
  );
}

export default Users;
